<template>
    <div class="block-editor get-supsis-record-by-id">
        <div class="wrapper">
            <section>
                <div class="editor-row-title">Module</div>
                <CustomPicker
                    v-model="clone.module"
                    :items="modules"
                    idKey="value"
                    labelKey="label"
                    :title="this.$t('message.selectModule')"
                    icon="filter_list"
                />
            </section>
            <section>
                <div class="title">ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type Record ID"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.id"
                        automation-mode
                    />
                </div>
            </section>
            <section v-if="clone.module === 'formSubmission'">
                <div class="title">Form</div>
                <CustomPicker
                    v-model="clone.formId"
                    :items="formsList"
                    idKey="_id"
                    labelKey="title"
                    :title="this.$t('message.selectForm')"
                    icon="text_snippet"
                />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import { CHATBOT_API } from "../../../../../../api/chatbotv2";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../components/pickers/CustomPicker.vue";
import { mapState } from "vuex";

const log = log2("GetSupsisRecordById");
export default {
    name: "GetSupsisRecordById",
    components: { TiptapEditor, CustomPicker },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            modules: [
                { label: this.$t("message.chat"), value: "chat" },
                { label: this.$t("message.task"), value: "task" },
                { label: this.$t("message.ticket"), value: "ticket" },
                { label: this.$t("message.calendarEvent"), value: "calendar-event" },
                { label: this.$t("message.reservation"), value: "reservation" },
                { label: this.$t("message.person"), value: "contact" },
                { label: this.$t("message.user"), value: "user" },
                //{ label: "Email (Not Implemented)", value: "email" },
                { label: this.$t("message.formSubmission"), value: "formSubmission" },
                //{ label: "Department (Not Implemented)", value: "department" },
                //{ label: "Channel (Not Implemented)", value: "channel" },
                //{ label: "Asset (Not Implemented)", value: "asset" },
                { label: "Ai Call", value: "ai-call" },
                { label: "YouTube Video", value: "youtube-video" },
                { label: "YouTube Yorum", value: "youtube-comment" },
            ],
        };
    },
    computed: {
        ...mapState({
            forms: (state) => state.forms.forms,
        }),
        formsList() {
            return this.forms.map((form) => ({
                _id: form._id,
                title: form.title,
            }));
        },
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    async created() {
        // Eğer mevcut değerde formId yoksa ve module formSubmission ise
        // varsayılan olarak ilk formu seç
        if (this.clone.module === "formSubmission" && !this.clone.formId && this.formsList.length) {
            this.clone.formId = this.formsList[0]._id;
        }
    },
};
</script>

<style lang="scss">
.block-editor.get-supsis-record-by-id {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .form-picker-wrapper {
            background: white;
            border-radius: 0px;
            border: 1px solid #fff;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
